import { ToastQueue } from '@react-spectrum/toast';

export const truncateText = (text: string, maxLength: number): string => {
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes >= 1073741824) {
    return (bytes / 1073741824).toFixed(2) + ' GB';
  } else if (bytes >= 1048576) {
    return (bytes / 1048576).toFixed(2) + ' MB';
  } else if (bytes >= 1024) {
    return (bytes / 1024).toFixed(2) + ' KB';
  } else {
    return bytes + ' bytes';
  }
};

export const openPdfContentInNewWindow = (fileSource: any): void => {
  try {
    const pdfUrl = typeof fileSource === "string" 
      ? fileSource 
      : URL.createObjectURL(new Blob([fileSource], { type: 'application/pdf' }));
    window.open(pdfUrl, '_blank');
  } catch (error) {
    console.error("Error opening PDF:", error);
    ToastQueue.negative("Error opening PDF file", { timeout: 3000 });
  }
};

export const showAttachment = (fileSource: any, fileName?: string): void => {
  const getFileExtension = (name: string): string => {
    return name ? name.split(".").pop()?.toLowerCase() || "" : "";
  };

  const extension = fileName ? getFileExtension(fileName) : "";

  if (extension === "pdf") {
    openPdfContentInNewWindow(fileSource);
  } else if (["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(extension)) {
    try {
      const imageUrl = typeof fileSource === "string"
        ? fileSource
        : URL.createObjectURL(new Blob([fileSource]));
      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Image Preview - ${fileName || "Image"}</title>
              <style>
                body { margin: 0; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f0f0f0; }
                img { max-width: 100%; max-height: 100vh; object-fit: contain; }
              </style>
            </head>
            <body>
              <img src="${imageUrl}" alt="${fileName || "Image"}" />
            </body>
          </html>
        `);
      }
    } catch (error) {
      console.error("Error opening image:", error);
      ToastQueue.negative("Error opening image file", { timeout: 3000 });
    }
  } else if (["txt", "json", "csv"].includes(extension)) {
    try {
      let textContent = "";
      if (typeof fileSource === "string") {
        textContent = fileSource.includes(",") 
          ? atob(fileSource.split(",")[1]) 
          : atob(fileSource);
      }

      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Text Preview - ${fileName || "Text File"}</title>
              <style>
                body { font-family: monospace; margin: 20px; white-space: pre-wrap; }
              </style>
            </head>
            <body>${textContent}</body>
          </html>
        `);
      }
    } catch (error) {
      console.error("Error opening text file:", error);
      ToastQueue.negative("Error opening text file", { timeout: 3000 });
    }
  } else {
    ToastQueue.info(
      `${fileName || "File"} will be available for download after sending the message`,
      { timeout: 3000 }
    );
  }
};